import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'unit',
    serviceName: 'graphql',
    query: gql`
      query unit($page: Int, $limit: Int, $title: String, $is_active: Int, $for_admin: Int) {
        unit(page: $page, limit: $limit, title: $title, is_active: $is_active, for_admin: $for_admin) {
          total
          last_page
          data {
            id
            title
            media {
              full_url
            }
          }
        }
      }
    `,
  },
  delete: {
    name: 'deleteUnit',
    serviceName: 'admin',
    query: gql`
      mutation deleteUnit($ids: [String]!) {
        deleteUnit(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'unit',
    serviceName: 'graphql',
    query: gql`
      query unit($ids: [String]) {
        unit(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'unit',
    serviceName: 'graphql',
    query: gql`
      query unit($ids: [String]) {
        unit(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
